<template>
  <div class="w-full">
    <div class="map-container flex w-full">
      <div v-if="isResultPage" class="top-[65px] w-full flex-none md:w-[380px]">
        <div class="w-full">
          <StoreFinderResults />
        </div>
      </div>
      <StoreFinderMap />
    </div>
    <div v-if="!isResultPage">
      <StoreFinderEntry />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  generateBreadcrumbSchema,
  getUrl,
  metaTagGenerator,
  type IBreadcrumbItem,
} from '~/utils/seo'

const { $currentShop } = useNuxtApp()

const route = useRoute()
const $i18n = useI18n()

const isResultPage = computed(() => !!route.query.location)

const breadcrumbSchema = computed((): IBreadcrumbItem[] => {
  return [
    {
      name: $i18n.t('store_finder.stores'),
      item: getUrl($currentShop.domain, route.fullPath),
    },
  ]
})
useJsonld(() => generateBreadcrumbSchema(breadcrumbSchema.value))

const metaTags = metaTagGenerator({
  description: $i18n.t('store_finder.seo_description'),
  robots: 'index,follow',
})

useSeoMeta({
  ...metaTags,
  title: $i18n.t('store_finder.seo_title'),
})

useHead({
  link: [
    {
      rel: 'canonical',
      key: 'canonical',
      href: sanitizeCanonical(getUrl($currentShop.domain, route?.path)),
    },
  ],
})

defineOptions({ name: 'NiederlassungenPage' })
definePageMeta({ pageType: 'search' })
</script>

<style lang="scss">
.map-container {
  height: calc(100vh - 63px);
}
</style>
